// ThirdEyeLogo: Inline SVG component for the ThirdEye logo.
// Renders three eyes in a triangle, colored to match the page's info/accent color.
import React from 'react';

interface ThirdEyeLogoProps {
  size?: number;
  color?: string;
  className?: string;
}

const ThirdEyeLogo: React.FC<ThirdEyeLogoProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    width={size}
    height={size}
    className={className}
    fill="none"
  >
    <defs>
      <g id="navbar-eye">
        <path
          d="M-42,0 Q0,-54 42,0 Q0,54 -42,0 Z"
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeLinejoin="round"
        />
        <circle cx="0" cy="0" r="17" fill="none" stroke={color} strokeWidth="4.5" />
        <circle cx="0" cy="0" r="7" fill={color} />
      </g>
    </defs>
    <use href="#navbar-eye" x="100" y="67" />
    <use href="#navbar-eye" x="46" y="133" />
    <use href="#navbar-eye" x="154" y="133" />
  </svg>
);

export default ThirdEyeLogo;
